import axiosInstance from 'api/axios';

interface createLimitReq {
  telegram_bot_id: string;
  service_id: number;
  usage_limit: number;
  reset_period: 'DAILY' | 'MONTHLY' | 'YEARLY';
}

const serviceLimitApis = {
  createLimit: async (data: createLimitReq) => {
    const response = await axiosInstance.private.post(
      '/api/v1/tele/service-limits',
      data
    );

    return response.data;
  },
  stopLimit: async ({ id, botId }: { id: number; botId: string }) => {
    const response = await axiosInstance.private.delete(
      `/api/v1/tele/service-limits/${id}?telegram_bot_id=${botId}`
    );

    return response.data;
  },
  getLimit: async (botId: string) => {
    const response = await axiosInstance.private.get(
      `/api/v1/tele/service-limits?telegram_bot_id=${botId}&role=user`
    );

    return response.data;
  },
  updateLimit: async ({
    id,
    data,
  }: {
    id: number;
    data: {
      telegram_bot_id: string;
      usage_limit: number;
      reset_period: 'DAILY' | 'MONTHLY' | 'YEARLY';
    };
  }) => {
    const response = await axiosInstance.private.put(
      `api/v1/tele/service-limits/${id}`,
      data
    );

    return response.data;
  },
};

export default serviceLimitApis;
